<section class="position-relative">
    <div class="container-fluid w-limit">
        <div class="row justify-content-center text-center align-items-center">
            <div class="col-12">
                <h1 class="fs-4 text-danger mt-2">Cobertura de tu seguro</h1>
                <p class="text-body-tertiary mb-4 fs-6 fw-semibold small mx-auto" style="max-width: 400px;">Conoce las
                    opciones de planes y coberturas que se ajustan a tu selección de tus necesidades.</p>
            </div>
        </div>
        <div class="row">
            <h2 class="fs-6 fw-semibold text-uppercase">
                <small>
                    Tu cotización
                </small>
            </h2>
        </div>
    </div>
</section>
<section class="py-4">
    <div class="container-fluid w-limit">
        <div class="row g-3 g-md-4">
            <div class="col">
                <div class="d-flex flex-column gap-3">
                    @if (currentDetails.length) {
                    @for (detail of currentDetails; track detail.id) {
                    <div class="card card-policy-summary border rounded-3 border-0 shadow">
                        <div
                            class="card-header bg-white border-bottom px=3 pt-3 pb-2 d-flex flex-column flex-sm-row justify-content-start justify-content-sm-between align-items-sm-center">
                            <h3 class="d-flex gap-3 align-items-center">
                                <span class="icon">
                                    <app-icon [name]="getSafeIconName(detail.insuranceType?.icon || 'hand-heart')"
                                        [size]="36" [strokeWidth]="2.2" color="#ce343c"></app-icon>
                                </span>
                                <span class="title lh-sm fs-5 fw-semibold text-start d-flex flex-column">
                                    <small class="fw-semibold text-primary small">{{
                                        getCategoryLabel(detail.insuranceType?.category)
                                        }}</small>
                                    @if (isLoading) {
                                    <span class="skeleton" style="width: 120px; height: 14px;"></span>
                                    } @else {
                                    <span class="small">{{ detailPlanName(detail.id) }}</span>
                                    }
                                </span>
                            </h3>
                            <div class="btn-item-header d-flex justify-content-between gap-2">
                                <button
                                    class="btn btn-sm btn-light bg-body-secondary d-flex align-items-center rounded-pill px-2 py-1"
                                    (click)="onEditDetail(detail)">Editar</button>
                                @if (currentDetails.length > 1){
                                <button
                                    class="btn btn-sm btn-light bg-body-secondary d-flex align-items-center rounded-pill px-2 py-1"
                                    (click)="onDeleteDetail(detail.id)">
                                    <app-icon name="trash-2" size="20" [strokeWidth]="2"></app-icon>
                                </button>
                                }
                            </div>
                        </div>
                        <div class="card-body p-3">
                            <div class="d-flex gap-2 justify-content-between align-items-center">
                                <div class="d-flex flex-column flex-md-row gap-3 gap-lg-5">
                                    <div class="summary-mount d-flex small flex-column">
                                        <small class="text-uppercase text-secondary fw-semibold small">Prima
                                            {{ paymentPlanLabel }} del seguro</small>
                                        @if (isLoading) {
                                        <span class="skeleton" style="width: 100px; height: 18px;"></span>
                                        } @else {
                                        <strong class="fw-semibold text-danger">{{ quoteCurrency }} {{
                                            detailNetPremium(detail.id) |
                                            number:'1.2-2' }}</strong>
                                        }
                                    </div>
                                    @if (hasCalculatedCoverage(detail) && getSurvivalBenefit(detail.id)) {
                                    <div class="summary-mount d-flex small flex-column">
                                        <small
                                            class="text-uppercase text-secondary fw-semibold small">Supervivencia</small>
                                        @if (isLoading) {
                                        <span class="skeleton" style="width: 100px; height: 18px;"></span>
                                        } @else {
                                        <strong class="fw-semibold text-success">{{ quoteCurrency }} {{
                                            getSurvivalBenefit(detail.id) |
                                            number:'1.2-2' }}</strong>
                                        }
                                        <small class="text-muted fst-italic" style="font-size: 0.7rem;">(Prima Anual ×
                                            Plazo)</small>
                                    </div>
                                    }
                                    @if (otherInsuredCount(detail) > 0) {
                                    <div class="summary-mount d-flex small flex-column">
                                        <small class="text-uppercase text-secondary fw-semibold small">Otros
                                            asegurados</small>
                                        <strong class="fw-semibold text-danger">{{ otherInsuredCount(detail) }}
                                            personas</strong>
                                    </div>
                                    }
                                </div>
                                @if (hasExpandableContent(detail)) {
                                <div>
                                    <button type="button"
                                        class="btn rounded-pill px-2 py-2 lh-sm border d-flex align-items-center justify-content-center fw-semibold btn-outline-light text-secondary btn-more"
                                        (click)="toggleExpansion(detail.id)">
                                        <app-icon
                                            [name]="isExpanded(detail.id) ? 'circle-arrow-up' : 'circle-arrow-down'"
                                            size="22" [strokeWidth]="2"></app-icon>
                                    </button>
                                </div>
                                }
                            </div>
                        </div>
                        <div class="card-footer border-top bg-white p-0" [class.d-none]="!isExpanded(detail.id)">
                            <!-- Coberturas adicionales: non-primary coverages only -->
                            @if(getNonRequiredCoverages(detail).length){
                            <div class="coberturas-item px-3 border-top border-2 mb-3">
                                <div class="row g-2 pt-3 pb-1">
                                    <div class="col-12 col-md-8">
                                        <label
                                            class="form-label mb-0 small fw-semibold text-muted text-uppercase uppercase d-block mb-2">Coberturas
                                            Adicionales</label>
                                    </div>
                                    <div class="col d-none d-md-block">
                                        <label
                                            class="form-label mb-0 small fw-semibold text-muted text-uppercase uppercase">Monto
                                            a asegurar</label>
                                    </div>
                                </div>
                                @for (cov of getNonRequiredCoverages(detail); track cov) {
                                <div class="row g-2 row-item-form align-items-center py-2"
                                    [class]="{ 'border-bottom': true }">
                                    <div class="col-12 col-md-8">
                                        <div
                                            class="form-check form-check-inline align-items-center d-flex gap-2 d-flex align-items-top gap-2">
                                            <input class="form-check-input focus-ring focus-ring-success"
                                                type="checkbox"
                                                [id]="'summary_covSel_' + detail.id + '_' + (cov.id || cov.name)"
                                                [checked]="isCoverageSelected(detail, cov)"
                                                [disabled]="isCoverageDisabledByAge(detail, cov)"
                                                (change)="onToggleCoverage(detail, cov, $any($event.target).checked)">
                                            <label
                                                class="form-check-label lh-sm fw-bold d-flex gap-2 align-items-center"
                                                [for]="'summary_covSel_' + detail.id + '_' + (cov.id || cov.name)">
                                                {{ cov.name }}
                                                <button #infoButton type="button"
                                                    class=" btn btn-sm p-0 btn-outline-light text-muted border-0 rounded-circle"
                                                    data-bs-toggle="popover" data-bs-placement="top"
                                                    data-bs-custom-class="custom-popover"
                                                    [attr.data-info-title]="cov.name || ''"
                                                    [attr.data-info-content]="cov.description || ''"
                                                    (click)="onInfoClick($event)"
                                                    aria-label="Más información sobre {{ cov.name }}">
                                                    <app-icon name="info" size="20" [strokeWidth]="2"
                                                        color="#9e9e9e"></app-icon>
                                                </button>
                                            </label>
                                            @if (isCoverageDisabledByAge(detail, cov)) {
                                            <small class="text-muted fst-italic d-block mt-1">No disponible para la edad
                                                del asegurado</small>
                                            }
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="d-block d-md-none mb-1 text-muted small text-uppercase">Monto
                                            a asegurar</div>
                                        <app-coverage-amount-input [formControl]="getControl(detail, cov)"
                                            [currency]="detail.currency ?? 'RD$'"
                                            [min]="getCoverageRange(detail, cov)?.minAmount"
                                            [max]="getCoverageRange(detail, cov)?.maxAmount" [placeholder]="'0.00'"
                                            [readonly]="isCoverageFixedLimit(detail, cov) || hasFraction(cov)">
                                        </app-coverage-amount-input>
                                        @if (getControl(detail, cov).touched && getControl(detail, cov).hasError('max'))
                                        {
                                        <div class="text-danger small mt-1">
                                            El valor asegurado no puede superar el monto de la cobertura principal.
                                        </div>
                                        }
                                        @if (getControl(detail, cov).touched && getControl(detail,
                                        cov).hasError('required')) {
                                        <div class="text-danger small mt-1">
                                            Debe ingresar un monto para la cobertura seleccionada.
                                        </div>
                                        }
                                    </div>
                                </div>
                                }
                            </div>
                            }

                            <!-- Beneficios de tu seguro: show values list, no cobertura column -->
                            @if ((detail.insuranceType?.benefits || []).length > 0) {
                            <div class="beneficios-items px-3 border-top border-3 mb-2">
                                <div class="row g-2 pt-3 pb-1">
                                    <div class="col-12">
                                        <label
                                            class="form-label mb-0 small fw-semibold text-muted text-uppercase uppercase d-block mb-2">Beneficios
                                            de tu seguro</label>
                                    </div>
                                </div>
                                @for (b of (detail.insuranceType?.benefits || []); track b) {
                                <div class="row g-2 small py-2 border-bottom">
                                    <div class="col-12">
                                        <strong class="lh-sm fw-normal d-flex gap-2 align-items-center">
                                            {{ b }}
                                        </strong>
                                    </div>
                                </div>
                                }
                            </div>
                            }

                        </div>
                    </div>
                    }
                    }
                </div>
            </div>
            <div class="col-12 col-lg-auto">
                <div class="card border-0 shadow rounded-3 summary-card w-100">
                    <div class="card-body">
                        <h3 class="fs-6 mb-3 fw-semibold text-uppercase d-flex gap-3 align-items-center">
                            <app-icon name="tickets" size="32" [strokeWidth]="2" color="#ce343c"></app-icon>
                            <small>Resumen de tu cotización</small>
                        </h3>
                        <div class="d-flex flex-column small gap-2 resumen-items">
                            <div class="bg-light text-dark rounded-3 p-2 px-3">
                                <div class="py-1">
                                    <strong>Plan seleccionado:</strong>
                                    @if (isLoading) {
                                    <span class="skeleton" style="width: 80px; height: 14px;"></span>
                                    } @else {
                                    {{ detailsCount }}
                                    }
                                </div>
                            </div>
                            <div class="bg-light text-dark rounded-3 p-2 px-3">
                                <div class="py-1">
                                    <strong>Pago anual:</strong>
                                    @if (isLoading) {
                                    <span class="skeleton" style="width: 80px; height: 14px;"></span>
                                    } @else {
                                    Pago único
                                    }
                                </div>
                            </div>
                            <div class="bg-light text-dark rounded-3 p-2 px-3">
                                <div class="py-1">
                                    <strong>Subtotal:</strong>
                                    @if (isLoading) {
                                    <span class="skeleton" style="width: 90px; height: 14px;"></span>
                                    } @else {
                                    {{ quoteCurrency }} {{ (summary?.totalNetPremium ?? 0) |
                                    number:'1.2-2' }}
                                    }
                                </div>
                            </div>
                            <div class="bg-light text-dark rounded-3 p-2 px-3">
                                <div class="py-1">
                                    <strong>ISC:</strong>
                                    @if (isLoading) {
                                    <span class="skeleton" style="width: 90px; height: 14px;"></span>
                                    } @else {
                                    {{ quoteCurrency }} {{ (summary?.totalTaxes ?? 0) |
                                    number:'1.2-2' }}
                                    }
                                </div>
                            </div>
                        </div>
                        <hr>
                        <label for="" class="form-label text-uppercase small fw-semibold">Total a pagar {{
                            paymentPlanLabel }}</label>
                        <div class="input-group">
                            @if (isLoading) {
                            <div class="input-group-text ps-2 pe-1 bg-transparent border-end-0 border-success">
                                <span class="badge fw-semibold text-secondary bg-secondary-subtle py-2 lh-sm fw-bold">{{
                                    quoteCurrency === 'USD' ? 'US$' : (quoteCurrency === 'DOP' ? 'RD$' : quoteCurrency)
                                    }}</span>
                            </div>
                            <div
                                class="form-control py-2 ps-1 border-success border-start-0 bg-white d-flex align-items-center">
                                <span class="skeleton" style="width: 100%; height: 20px;"></span>
                            </div>
                            } @else {
                            <div class="input-group-text ps-2 pe-1 bg-transparent border-end-0 border-success">
                                <span class="badge fw-semibold text-secondary bg-secondary-subtle py-2 lh-sm fw-bold">{{
                                    quoteCurrency === 'USD' ? 'US$' : (quoteCurrency === 'DOP' ? 'RD$' : quoteCurrency)
                                    }}</span>
                            </div>
                            <input type="text" mask="separator.2" thousandSeparator=","
                                [ngModel]="summary?.totalGrossPremium ?? 0" id="insuranceItemMainCoverage"
                                placeholder="0.00"
                                class="form-control py-2 ps-1 focus-ring border-success fw-bold focus-ring-success border-start-0 bg-white"
                                disabled>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<footer class="border-bottom border-5">
    <div class="container-fluid w-limit">
        <div class="row justify-content-between g-2 py-4">
            <div class="col-auto">
                <button class="btn btn-outline-secondary rounded-pill"
                    [routerLink]="['/quote/insurance-types']">Retroceder</button>
            </div>
            <div class="col-auto">
                <div class="d-flex gap-3">
                    <button class="btn btn-outline-danger rounded-pill" (click)="onDownloadQuote()"
                        [disabled]="hasErrors">Descargar
                        cotización</button>
                    <button class="btn btn-primary rounded-pill" [routerLink]="['/quote/checkout']"
                        [disabled]="hasErrors">Guardar y
                        continuar</button>
                </div>
            </div>
        </div>
    </div>
</footer>